const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getAdmins = async (page = 1, perPage = 50, filters = {}) => {
    const token = localStorage.getItem('token');
    let queryParams = `page=${page}&per_page=${perPage}`;

    for (const key in filters) {
        if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
            queryParams += `&${encodeURIComponent(key)}=${encodeURIComponent(filters[key])}`;
        }
    }

    try {
        const response = await fetch(
            `${API_BASE_URL}/admin/user/admin-accounts?${queryParams}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Ошибка при получении данных сотрудников");
        }

        const result = await response.json();
        console.log(result)

        return {
            data: result.data,
            meta: {
                total_count: result.meta?.total || 0,
                current_page: result.meta?.current_page || page,
                per_page: result.meta?.per_page || perPage,
                total_pages: result.meta?.last_page || 1
            }
        };

    } catch (error) {
        console.error("Ошибка при получении сотрудников:", error);
        throw error;
    }
};